<div class="optionList">
    <div class="categoryContent">
        <app-categories *ngIf="showCategories" (categoryOutput)="categoryClicked($event)"
                        [page]="'ordering'"></app-categories>
    </div>


    <div class="searchContent">
        <button (click)="onCartFilter(true)" [class.cartColor]="isCartEnabled"
                class="cartIcon"
                color="secondary"
                id="btn-orderedCart"
                mat-mini-fab
                matBadge={{totalItemsOrdered}}
                matBadgeColor="primary">
            <span class="k-icon k-font-icon k-i-cart"></span>
        </button>

        <div class="search">
            <span class="fa fa-search"></span>
            <input (ngModelChange)="textboxChanged($event)" [(ngModel)]="searchText" class="searchItem"
                   id="inp-searchBox"
                   kendoTextBox
                   placeholder="Description or Item Number"/>
        </div>
    </div>
</div>
<OrderUploadComponent [itemInsert]="itemInsert"></OrderUploadComponent>
<div class="OrderPage">
    <div class="gridHolder">

        <kendo-grid
            #orderingGrid
            [inCellTab]="selectedRow"
            [inputsClicked]="parentSubject"
            (dataStateChange)="dataStateChange($event)"
            (pageChange)="pageChange($event)"
            [data]="gridData"
            [filter]="state.filter"
            [filterable]="true"
            [kendoGridSelectBy]="'itemNo'"
            [loading]="loading"
            [navigable]="false"
            [pageSize]="state.take"
            [skip]="state.skip"
            [reorderable]="true"
            [resizable]="true"
            [selectedKeys]="selection"
            [sortable]="true"
            [sort]="state.sort"
            [rowHeight]="48"
            (excelExport)="excelExported($event)"
            id="grid-Ordering"
            scrollable="virtual"
            style="height: 100%">

            <ng-template kendoGridToolbarTemplate>
                <kendo-grid-spacer></kendo-grid-spacer>
                <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(orderingGrid)" text="Export to PDF"
                [svgIcon]='filePdfIcon' primary="true"></app-mcl-button>
                <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(orderingGrid)" [svgIcon]="fileExcelIcon"
                            primary="true" text="Export to Excel"></app-mcl-button>
            </ng-template>

            <kendo-grid-column [title]="Nomenclatures.ITEM_NUMBER" field="itemNo" filterable="true" width="160">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <p *ngIf="gridData">
                        {{gridData.total}} Item(s)</p>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column *ngFor="let col of columns"
                               [editable]="false"
                               [field]="col.field"
                               [filterable]="col.filterable"
                               [format]="col.format"
                               [media]="col.media"
                               [title]="col.title"
                               [width]="col.width"
                               headerClass="HeaderGrid">
            </kendo-grid-column>


            <kendo-grid-column *ngIf="!isHidden(Nomenclatures.qtyLastOrdered)"
                               field="{{Nomenclatures.qtyLastOrdered}}"
                               media='(min-width: 768px)'
                               title="{{Nomenclatures.QUANTITY_LAST_ORDERED}}"
                               width='150'>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="!isHidden(Nomenclatures.qtySuggested)"
                               field="{{Nomenclatures.qtySuggested}}"
                               media='(min-width: 768px)'
                               title="{{Nomenclatures.SUGGESTED_QUANTITY}}"
                               width='150'>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

                    <div kendoTooltip
                         filter=".sug"
                         [titleTemplate]="titleTemplate"
                         [tooltipTemplate]="template"
                         position="bottom"
                         tooltipClass="tooltipSug"
                    >

                        <ng-template #titleTemplate let-anchor>
                            <div>Suggested Order Calculation</div>
                        </ng-template>
                        <ng-template #template let-anchor>
                            <div class="suggestedGrid">
                                <div class="buildToQtyHeader">Build-To Qty</div>
                                <div class="onHandHeader">On Hand Qty</div>
                                <div class="onOrderQtyHeader">On Order Qty</div>
                                <div class="qtySuggestedHeader">Suggested Qty</div>
                                <div class="buildToQty">{{dataItem.buildToQty}}</div>
                                <div class="minus">-</div>
                                <div class="onHandQty">{{dataItem.qoh}}</div>
                                <div class="minustwo">-</div>
                                <div class="openorderQty">{{dataItem.openOrderQty}}</div>
                                <div class="equals">=</div>
                                <div class="qtySuggested">{{dataItem.qtySuggested}}</div>
                            </div>


                        </ng-template>
                        <p class="sug">{{dataItem.qtySuggested}}</p>
                    </div>
                </ng-template>
            </kendo-grid-column>


            <kendo-grid-column [title]="Nomenclatures.QUANTITY" field="quantity" filter="numeric" format="{0:n0}"
                               width="150">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="whole_cell">
                    <input #inputQuantity (blur)="quantityChanged(dataItem)"
                           [id]="rowIndex"
                           (focus)="quantityFocused(dataItem.itemNo)"
                           maxlength="3"
                           kendoGridFocusable
                           *ngIf="dataItem.activeFlagbool"
                           [(ngModel)]="dataItem.quantity"
                           [attr.data-item-id]="dataItem.itemNo"
                           [disabled]="!dataItem.activeFlagbool"
                           [ngClass]="{ 'critical_item_unfilled': (dataItem.critical && dataItem.quantity<=0)}"
                           class="inputOrdering"
                           (click)="inputClicked($event)"
                           digitsOnly style="text-align: center"/>

                      <!-- Add a hidden input to stop hold items from causing focus to be stuck on last item.  -->
                      <i *ngIf="!dataItem.activeFlagbool" class="material-icons hold_item">pan_tool
                          <input class="hiddenInput"/>
                     </i>

                   </span>

                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-column="column" let-filter>
                    <kendo-grid-numeric-filter-cell
                            [column]="column"
                            [filter]="filter"
                            [min]=0
                            [max]="999999999">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>

                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    {{totalItemsOrdered }} Total Cases
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [filter]="'boolean'" [title]="Nomenclatures.CRITICAL" field="critical" width="80">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="whole_cell">
                    <mat-icon *ngIf="dataItem.critical" matTooltip="This is a Critical Item"
                              style="color: orange">warning</mat-icon>
                      <mat-icon *ngIf="!dataItem.showIndicator" matTooltip="This is a Hidden Item"
                                style="color: darkgray">visibility_off</mat-icon>
                  </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [title]="Nomenclatures.COST" field="price" filter="numeric" format="{0:c}" width="150">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    {{totalPrice | currency}} Estimated Total
                </ng-template>

                <ng-template kendoGridFilterCellTemplate let-column="column" let-filter>
                    <kendo-grid-numeric-filter-cell
                            [column]="column"
                            [filter]="filter"
                            [min]=0
                            [max]="999999999">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>

            </kendo-grid-column>

            <kendo-grid-pdf fileName="OrderGuideWorksheet.pdf" [author]="'McLane'" [producer]="'McLane'"
                            [allPages]="true" paperSize="A4" [repeatHeaders]="false" [scale]="0.8">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="1cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">

                    <div class="page-template">
                        <div class="header" *ngIf="pageNum == 1">
                            <p *ngIf="!isCartEnabled">SourceLink - Order Work Sheet</p>
                            <p *ngIf="isCartEnabled">SourceLink - Order Work Sheet cart</p>
                            <p>Store: {{_storeListService.pickedIdentity}}</p>
                            <p>{{ today | date}}</p>
                        </div>
                        <div class="header" *ngIf="pageNum != 1">
                            <p>SourceLink - Order Work Sheet : {{ today | date}}</p>

                        </div>
                    </div>
                </ng-template>

                <kendo-grid-column [title]="'Item #'" field="itemNo"  [headerStyle]="{'font-size': '9px'}"
                                   [style]="{'font-size': '9px'}" width="50">
                                   <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                                    <p *ngIf="gridData" style="font-size: 9px;">
                                        {{gridData.total}} Item(s)</p>
                                </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [title]="Nomenclatures.DESCRIPTION" field="description"
                                   [headerStyle]="{'font-size': '9px'}" [style]="{'font-size': '9px'}" width="180" >
                </kendo-grid-column>
                <kendo-grid-column [title]="'Build To Quantity'" field="buildToQty" width="60"
                                   [style]="{'font-size': '9px'}"
                                   [headerStyle]="{'font-size': '9px','white-space': 'normal','line-height': '1.2', 'text-align': 'center'}">
                                   <ng-template kendoGridHeaderTemplate>
                                    <div class="pdf-header-style">
                                        Build<br>To <br> Quanity
                                    </div>
                                </ng-template>
                </kendo-grid-column>
                <kendo-grid-column-group title="Order Quantity" [style]="{'font-size': '9px',}"
                                         [headerStyle]="{'font-size': '10px'}">
                    <kendo-grid-column [title]="1" width="40" [headerStyle]="{'font-size': '9px'}">
                    </kendo-grid-column>
                    <kendo-grid-column [title]="2" width="40" [headerStyle]="{'font-size': '9px'}">
                    </kendo-grid-column>
                    <kendo-grid-column [title]="3" width="40" [headerStyle]="{'font-size': '9px'}">
                    </kendo-grid-column>
                    <kendo-grid-column [title]="4" width="40" [headerStyle]="{'font-size': '9px'}">
                    </kendo-grid-column>
                    <kendo-grid-column [title]="5" width="40" [headerStyle]="{'font-size': '9px'}">
                    </kendo-grid-column>               
                </kendo-grid-column-group>
                <kendo-grid-column [title]="Nomenclatures.UNIT_OF_MEASURE" 
                                   field="unitOfMeasure"
                                   [style]="{'font-size': '9px'}" 
                                   [headerStyle]="{'font-size': '9px','white-space':'normal','line-height':'1.2','text-align': 'center'}" 
                                   width="70">
                                   <ng-template kendoGridHeaderTemplate>
                                    <div class="pdf-header-style">
                                        Unit<br>of <br> Measure
                                    </div>
                                </ng-template>
                                   <ng-template *ngIf="isCartEnabled" kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                                    {{totalItemsOrdered }} Total Cases
                                </ng-template>
                </kendo-grid-column>

                <kendo-grid-column  [title]="Nomenclatures.QUANTITY" field="quantity" filter="numeric"  [style]="{'font-size': '9px'}" 
                                    [headerStyle]="{'font-size': '9px'}" width="60">                                   
                </kendo-grid-column>
                <kendo-grid-column [title]="'Case Price'" field="perCost"
                                   [style]="{'font-size': '9px'}" format="{0:c}"
                                   [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}"
                                   width="70">
                                   <ng-template kendoGridHeaderTemplate>
                                    <div class="pdf-header-style">
                                        Case<br>Price
                                    </div>
                                </ng-template>
                                   <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex" [style]="{'font-size': '9px'}">
                                    {{totalPrice | currency}} Total                              
                                </ng-template>
                </kendo-grid-column>
            </kendo-grid-pdf>
            <kendo-grid-excel fileName="OrderGuideWorksheet.xlsx" [fetchData]="exportAllData" [allPages]="true">
                <kendo-excelexport-column [title]="'Item #'" field="itemNo" width="170" [cellOptions]="">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="Nomenclatures.DESCRIPTION" field="description" width="250">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="Nomenclatures.BUILD_TO_QTY" field="buildToQty" width="170">
                </kendo-excelexport-column>
                <kendo-excelexport-column-group title="Order Quantity" [style]="{'font-size': '10px'}"
                                                [headerCellOptions]="{}">
                    <kendo-excelexport-column [title]="1" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="2" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="3" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="4" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="5" field="0" width="80">
                    </kendo-excelexport-column>
                </kendo-excelexport-column-group>
                <kendo-excelexport-column [title]="Nomenclatures.QUANTITY" field="quantity" filter="numeric"  [style]="{'font-size': '10px'}" 
                                           [headerStyle]="{'font-size': '10px'}" width="80"></kendo-excelexport-column>
                <kendo-excelexport-column [title]="Nomenclatures.UNIT_OF_MEASURE" field="unitOfMeasure" width="170">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="'Case Price'" field="perCost" [width]="80">
                </kendo-excelexport-column>
            </kendo-grid-excel>
        </kendo-grid>
    </div>
    <div class="bottomHolder">
        <div>

            <div class="buttonHolder">
                <div class="buttonflex">
                    <!-- <app-mcl-button [disabled]="_buttonStatus" id="but-copy" (buttonPressed)="copyOrder()" text="Copy Order"
                                 [hidden]="_copyOrderButtonHidden" icon="copy" primary="true"></app-mcl-button>-->
                    <app-mcl-button [disabled]="_buttonStatus" id="but-cancel" (buttonPressed)="navigate()" text="Cancel"
                                [hidden]="_cancelOrderButtonHidden" [svgIcon]="cancelIcon"></app-mcl-button>
                    <app-mcl-button [disabled]="_buttonStatus" id="but-qty"
                                (buttonPressed)="lastQtyOrSuggested(this.qtyButtonBool)" [svgIcon]="trackAllchanges"
                                [hidden]="_lastQtyOrderButtonHidden" text={{this.qtyButtonText}}
                                ></app-mcl-button>
                    <app-mcl-button *ngIf="!_buttonStatusUpload" [disabled]="_buttonStatusUpload" id="but-upload"
                                (buttonPressed)="uploadOrder()"
                                text="Upload Order"
                                [svgIcon]="uploadIcon"></app-mcl-button>
                    <app-mcl-button [disabled]="_buttonStatus" id="but-save" (buttonPressed)="saveOrder()" text="Save Order"
                                [svgIcon]="saveIcon" primary="true"></app-mcl-button>
                    <app-mcl-button [hidden]="_reviewOrderButtonHidden" [disabled]="_buttonStatus" id="but-review"
                                (buttonPressed)="reviewOrder()"
                                text="Review Order" [svgIcon]="eyeIcon" primary="true"></app-mcl-button>
                    <app-mcl-button [hidden]="_returnToOrderButtonHidden" [disabled]="_buttonStatus" id="but-return"
                                (buttonPressed)="returnToOrder()"
                                text="Return to Order" [svgIcon]="undoIcon" primary="true"></app-mcl-button>
                    <app-mcl-button [hidden]="_submitOrderButtonHidden" [disabled]="_buttonStatus" id="but-submit"
                                (buttonPressed)="submitOrder()"
                                text="Submit Order" [svgIcon]="uploadIcon" primary="true"></app-mcl-button>
                </div>
            </div>
        </div>
    </div>
</div>

<div kendoDialogContainer></div>
